import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { InvitationState } from '../../../../../redux/invitations/invitation.model';

export const StyledChip = styled(Box)(({ theme }) => ({
  borderRadius: '0.4rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'uppercase',
  padding: '1.5rem 1rem',
}));

export const getStatusColor = (
  state: InvitationState
): { color: string; backgroundColor: string } => {
  switch (state) {
    case InvitationState.APPROVED:
      return {
        color: 'success.main',
        backgroundColor: 'rgb(242 251 244)',
      };
    case InvitationState.REJECTED:
      return {
        color: 'error.main',
        backgroundColor: 'error.contrastText',
      };
    case InvitationState.NEW:
      return {
        color: 'rgb(37 118 170)',
        backgroundColor: 'rgb(232 241 246)',
      };
    case InvitationState.SENT:
      return {
        color: 'warning.main',
        backgroundColor: 'warning.light',
      };
    case InvitationState.CANCELED:
      return {
        color: 'gray.dark',
        backgroundColor: 'gray.light',
      };
    default:
      return {
        color: 'default.main',
        backgroundColor: 'default.light',
      };
  }
};
